module.exports = __webpack_public_path__ + "img/943-e61380.png";